module.exports = __webpack_public_path__ + "slide9.jpg?f4c127533a7770f0ac5589efed26e6e2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide9.jpg
// module id = 318
// module chunks = 0